module.exports = __webpack_public_path__ + "static/emision1-624b41fb66cd2228c50f29b961c91102.jpg";